import httpClient from './client'

export default {
  // 直播间详情
  async getTraderToken () {
    const url = `/trade/hjzq/token`
    const res = await httpClient.get(url)
    return res && res.data && res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/trader.js